/**
 * Route paths, in Portuguese — the interface has no other language and a URL the user
 * can read is part of the product. Centralised so a rename is one edit, not a grep.
 */

export const routes = {
  /**
   * A raiz é a **timeline** (canvas 1p). O resumo pessoal que morava aqui desceu para
   * `stats`, e os gráficos que moravam em `stats` foram para `statsDetailed`.
   */
  home: '/',
  login: '/entrar',
  register: '/criar-conta',

  friends: '/amigos',
  addFriend: '/amigos/adicionar',
  /**
   * O perfil de outro jogador (canvas 3a/3b). Segmento próprio, e não `/amigos/:id`: ali
   * `adicionar` já é um caminho literal e passaria a ser lido como um id.
   */
  player: (userId: string) => `/jogadores/${userId}`,
  playerRounds: (userId: string) => `/jogadores/${userId}/voltas`,

  rounds: '/voltas',
  round: (id: string) => `/voltas/${id}`,

  record: '/registrar',
  /** A tela de entrada num flight de outra pessoa (canvas 2a) — o destino do convite no feed. */
  joinFlight: (groupRoundId: string) => `/entrar-na-volta/${groupRoundId}`,

  courses: '/campos',
  course: (id: string) => `/campos/${id}`,
  hole: (courseId: string, holeNumber: number) => `/campos/${courseId}/buracos/${holeNumber}`,

  stats: '/estatisticas',
  statsDetailed: '/estatisticas/detalhados',
  profile: '/perfil',
} as const;

/** Route patterns, for <Route path=...>. Keep in sync with the builders above. */
export const patterns = {
  round: '/voltas/:roundId',
  course: '/campos/:courseId',
  hole: '/campos/:courseId/buracos/:holeNumber',
  joinFlight: '/entrar-na-volta/:groupRoundId',
  player: '/jogadores/:userId',
  playerRounds: '/jogadores/:userId/voltas',
} as const;
